import { render } from "./ActiveCheckups.vue?vue&type=template&id=49f2d8f7&scoped=true"
import script from "./ActiveCheckups.vue?vue&type=script&lang=js"
export * from "./ActiveCheckups.vue?vue&type=script&lang=js"

import "./ActiveCheckups.vue?vue&type=style&index=0&id=49f2d8f7&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f2d8f7"]])

export default __exports__